import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from '@delhivery/auth';
import { LoginComponent, ForbiddenComponent } from '@app/core/components';
import { AuthGuardService } from '@app/core/services';
const appRoutes: Routes = [
  {
    path: 'lib-auth-oauth-callback',
    component: AuthComponent,
  },
  // Profile editing isn't offered in this app; AuthModule registers this route, so override it.
  { path: 'lib-user-profile', redirectTo: '' },
  {
    path: '',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule),
    canActivate: [ AuthGuardService ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ AuthGuardService ],
  },
  {
    path: 'print',
    loadChildren: () => import('./printlayout/printlayout.module').then(m => m.PrintModule)
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  { path: '**', pathMatch: 'full', redirectTo: '' },
];

@NgModule({
  imports: [ RouterModule.forRoot(appRoutes, { useHash: false }) ],
  exports: [ RouterModule ]
})
export class AppRoutesModule { }
